export class PushTokenApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Create or update a push notification token for a user
     * @returns PushTokenResult Token successfully updated.
     * @throws ApiError
     */
    createOrUpdateToken({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/push-token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove a push notification token for a user
     * @returns PushTokenResult Token successfully deleted.
     * @throws ApiError
     */
    removeToken({ requestBody, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/push-token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Retrieve push notification tokens for a user
     * @returns PushToken Tokens retrieved successfully
     * @throws ApiError
     */
    getTokens() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/push-token',
        });
    }
    /**
     * Clear the badge count for a user
     * @returns any Badge count cleared successfully
     * @throws ApiError
     */
    clearBadgeCount({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/push-token/clear-badge-count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    getAllRedis({ userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/push-token/redis-user',
            query: {
                'userId': userId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    deleteRedisUser({ userId, socketId, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/push-token/redis-user',
            query: {
                'userId': userId,
                'socketId': socketId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    createRedisSocket({ userId, socketId, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/push-token/redis-socket',
            query: {
                'userId': userId,
                'socketId': socketId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    deleteRedisSocket({ userId, socketId, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/push-token/redis-socket',
            query: {
                'userId': userId,
                'socketId': socketId,
            },
        });
    }
}
